module.exports = __webpack_public_path__ + "static/media/3_4.9ad5e002.jpg";